<template>
  <layout>
    <template v-slot:header>
      <global-navigation></global-navigation>
    </template>

    <main v-if="hasPage" class="Editorial">
      <div class="container">
        <div class="header">
          <div class="meta">
            <span v-if="page.date">{{ page.date }}</span>
            <a v-if="page.publication && page.source" :href="page.source">
              {{ page.publication }}
            </a>
            <span v-else-if="page.publication">{{ page.publication }}</span>
            <span v-if="page.publicationinfo">{{ page.publicationinfo }}</span>
          </div>
          <h1>
            {{ page.title }}
          </h1>
          <div class="details" v-html="page.metatext"></div>
        </div>
        <rich-text 
          :class="['content', { 'not-found': isNotFound }]"
          :content="page.text"
        />
        <div class="footer copy links">
          <a :href="page.source">{{ page.publication }}</a>
        </div>
      </div>
    </main>

    <template v-slot:footer>
      <global-footer :border="true"></global-footer>
    </template>
  </layout>
</template>

<script>
import PageMixin from '@/mixins/PageMixin'
import RichText from '@/components/RichText'

export default {
  name: 'Page',
  mixins: [ PageMixin ],
  components: { RichText }
}
</script>

<style scoped>
.container { padding: 4rem 22% 10rem 22%; }

@media (max-width: 1360px) {
  .container { padding: 4rem 20% 8rem 20%; }
}

@media (max-width: 1000px) {
  .container { padding: 4rem 2rem 8rem 2rem }
}

.content {
  margin-top: 6rem;
}

.header > * + * {
  margin-top: 2rem;
}

h1 {
  font-size: 3.4rem;
}

.meta {
  font: var(--nord);
  text-transform: uppercase;
}

.meta > * {
  margin-right: 2rem;
}

.details {
  font: var(--nord);
}

.footer {
  margin-top: 6rem;
  text-align: center;
  font: var(--nord);
}

article::v-deep figure.wide {
  padding-left: 0;
  padding-right: 0;
}

article::v-deep figure.full {
  padding-left: 0;
  padding-right: 0;
  width: calc(174%);
  margin-left: -37%;
}

@media (max-width: 1360px) {
  article::v-deep figure.full {
    width: calc(162%);
    margin-left: -31%;
  }
}

@media (max-width: 1000px) {
  article::v-deep figure.full {
    width: 100%;
    margin-left: 0;
  }
}
</style>